import { create } from 'zustand';

export const usePostSound = create(set => ({
  post_sound: '',
  clearSoundPost: '',
  postChunks: [],
  setSoundPost: value => set({ post_sound: value }),
  setPostChunks: _item => set({ postChunks: _item }),
}));
